import { message } from 'antd';
import { downloadCSVFromText } from 'helpers/util.helpers';
import { defaultApiErrorSchema } from 'lib/api/utils';
import { useGenerateFinanceReportMutation } from 'lib/hooks/reports/reports.mutations';
import React from 'react';

function FinanceReportCard() {
  const { mutateAsync: generateFinanceReport, isLoading } =
    useGenerateFinanceReportMutation();

  const downloadReportHandler = async () => {
    try {
      const { data, fileName } = await generateFinanceReport();

      downloadCSVFromText(data, fileName || 'finance-report.csv');

      message.success('Report generated successfully');
    } catch (e) {
      const apiErrorMessage =
        defaultApiErrorSchema.safeParse(e)?.data?.data.message;

      message.error(apiErrorMessage || 'Failed to generate report');
    }
  };

  const buttonText = isLoading ? 'Generating...' : 'Generate Report';

  return (
    <div className="card">
      <div className="card-header d-flex align-items-center">
        <div className="col-md-9">
          <h5 className="card-title">Monthly Finance Report</h5>
        </div>
      </div>

      <button
        className="btn btn-lg btn-purple btn-view-all"
        disabled={isLoading}
        onClick={() => downloadReportHandler()}
      >
        {buttonText}
      </button>
    </div>
  );
}

export default FinanceReportCard;
